import { render } from "./ClientAreaMain.vue?vue&type=template&id=f396b84a&scoped=true"
import script from "./ClientAreaMain.vue?vue&type=script&lang=js"
export * from "./ClientAreaMain.vue?vue&type=script&lang=js"

import "./ClientAreaMain.vue?vue&type=style&index=0&id=f396b84a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f396b84a"]])

export default __exports__